// Copyright (c) StrangeBee 2024

import { HeaderButton } from '@Atoms/Buttons';
import { ICONS } from '@Constants/iconsApp';
import React, { ReactElement } from 'react';

import './ActionWidget.scss';

interface ActionWidgetProps {
    onDownloadImage?: () => void;
    onDownloadCSV?: () => void;
    onDownloadTXT?: () => void;
}

export const ActionWidget = ({ onDownloadImage, onDownloadCSV, onDownloadTXT }: ActionWidgetProps): ReactElement => (
    <div className="action-widget">
        {onDownloadImage && (
            <HeaderButton icon={<ICONS.FileImageOutlined />} label="Download as PNG" onClick={onDownloadImage} />
        )}

        {onDownloadCSV && (
            <HeaderButton icon={<ICONS.FileCSVOutlined />} label="Download as CSV" onClick={onDownloadCSV} />
        )}

        {onDownloadTXT && <HeaderButton icon={<ICONS.JobIcon />} label="Download as TXT" onClick={onDownloadTXT} />}
    </div>
);
